import React from 'react'
import { useSelector } from 'react-redux'

import { _chatMessages, _isMessagesTabOpen } from 'store/selectors/Chat'

import { ChatFeedContainer, ChatFeedInnerContainer } from './styles'
import TextMessageView from './TextMessageView'

const ChatFeed = ({}) => {
    const messages = useSelector(_chatMessages)
    const isMessagesTabOpen = useSelector(_isMessagesTabOpen)

    const getIsContinued = index => {
        return (
            index > 0 &&
            messages[index - 1].senderUid === messages[index].senderUid
        )
    }

    const renderMessageView = (message, index) => {
        const isContinued = getIsContinued(index)
        switch (message.type) {
            case 'text':
                return (
                    <TextMessageView
                        key={index}
                        message={message}
                        isContinued={isContinued}
                    />
                )
            case 'gesture':
                return (
                    <TextMessageView
                        key={index}
                        message={message}
                        isContinued={isContinued}
                        isGesture={true}
                    />
                )

            default:
                return null
        }
    }

    return (
        <ChatFeedContainer>
            <ChatFeedInnerContainer>
                {messages
                    .filter(message =>
                        isMessagesTabOpen ? message.type === 'text' : true
                    )
                    .map((message, index) => renderMessageView(message, index))}
            </ChatFeedInnerContainer>
        </ChatFeedContainer>
    )
}

export default React.memo(ChatFeed)
